import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import injectSheet from 'react-jss';

import { Button } from '~/eds/src/components/Button/Button';
import { Markdown } from '~/eds/src/components/Markdown/Markdown';
import { Modal } from '~/eds/src/components/Modal/Modal';
import { injectIntl } from 'react-intl';
import HtmlContent from '~/ui/components/HtmlContent/HtmlContent';

import { evisortBlue } from '../../../assets/shared-styles/general';
import { MODAL_CKEDITOR, MODAL_DELETE } from '../../../types/modal.types';
import EcCard from '../EcCard/EcCard';
import EcModal from '../EcModal/EcModal';
import DocumentOutlineIcon from '../Icons/DocumentOutlineIcon';
import styles from './EcTable.styles';

const cardContentStyles = { padding: '16px' };

class EcTable extends Component {
  constructor(props) {
    super(props);

    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleSaveTable = this.handleSaveTable.bind(this);
    this.handleDeleteTable = this.handleDeleteTable.bind(this);
    this.state = { currentModal: null };
  }

  handleShowModal(modal) {
    this.setState({ currentModal: modal });
  }

  handleHideModal() {
    this.setState({ currentModal: null });
  }

  handleDeleteTable() {
    const { tableId, handleTableDelete } = this.props;

    handleTableDelete(tableId);
  }

  handleSaveTable(newTableContent) {
    const { tableId, handleTableUpdate } = this.props;

    handleTableUpdate(tableId, newTableContent);
  }

  renderCKEditorModal() {
    const {
      tableContent,
      allowRowChanges,
      allowColumnChanges,
      allowCellChanges,
    } = this.props;

    return (
      <EcModal
        width="80%"
        modalType={MODAL_CKEDITOR}
        tableContent={tableContent}
        hideModal={this.handleHideModal}
        handleActionClick={this.handleSaveTable}
        allowRowChanges={allowRowChanges}
        allowColumnChanges={allowColumnChanges}
        allowCellChanges={allowCellChanges}
      />
    );
  }

  renderDeleteModal() {
    const { tableName, intl } = this.props;

    return (
      <Modal
        isVisible
        title={intl.formatMessage({
          id: 'EcTable.deleteTableTitle',
          defaultMessage: 'Delete Table?',
          description: 'Modal title for delete table confirmation',
        })}
        children={
          <Markdown
            text={intl.formatMessage(
              {
                id: 'EcTable.deleteTableConfirmation',
                defaultMessage: `Are you sure you want to delete {tableName}? You won't be able to undo this action.`,
                description:
                  'Confirmation message for deleting a table. Example: tableName = "Document Name"',
              },
              { tableName },
            )}
          />
        }
        primaryAction={{
          text: intl.formatMessage({
            id: 'EcTable.deleteButton',
            defaultMessage: 'Delete',
            description: 'Delete button text',
          }),
          variant: 'danger',
          onClick: () => {
            this.handleDeleteTable();
            this.handleHideModal();
          },
        }}
        onHide={this.handleHideModal}
        onCancel={this.handleHideModal}
      />
    );
  }

  renderRightComponent() {
    const { intl } = this.props;
    return (
      <>
        <Button
          text={intl.formatMessage({
            id: 'EcTable.editTableButton',
            defaultMessage: 'Edit Table',
            description: 'Button text for editing table',
          })}
          onClick={() => this.handleShowModal(MODAL_CKEDITOR)}
          variant="action"
        />
        <Button
          text={intl.formatMessage({
            id: 'EcTable.deleteTableButton',
            defaultMessage: 'Delete Table',
            description: 'Button text for deleting table',
          })}
          onClick={() => this.handleShowModal(MODAL_DELETE)}
          variant="action"
        />
      </>
    );
  }

  render() {
    const { classes, tableName, tableContent } = this.props;
    const { currentModal } = this.state;

    return (
      <Fragment>
        <EcCard
          title={
            <Fragment>
              <DocumentOutlineIcon color={evisortBlue} />
              {tableName}
            </Fragment>
          }
          contentStyles={cardContentStyles}
          titleRightComponent={this.renderRightComponent()}
        >
          <HtmlContent className={classes.tablesItem} html={tableContent} />
        </EcCard>
        <div className={classes.horizontalSeparator} />
        {currentModal === MODAL_CKEDITOR ? this.renderCKEditorModal() : null}
        {currentModal === MODAL_DELETE ? this.renderDeleteModal() : null}
      </Fragment>
    );
  }
}

EcTable.propTypes = {
  classes: PropTypes.object.isRequired,
  tableId: PropTypes.number.isRequired,
  tableName: PropTypes.string.isRequired,
  tableContent: PropTypes.string.isRequired,
  handleTableUpdate: PropTypes.func.isRequired,
  handleTableDelete: PropTypes.func.isRequired,
  allowRowChanges: PropTypes.bool.isRequired,
  allowColumnChanges: PropTypes.bool.isRequired,
  allowCellChanges: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectSheet(styles)(injectIntl(EcTable));
